import _to_array from "@swc/helpers/src/_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Close from "@mui/icons-material/Close";
import Error from "@mui/icons-material/Error";
import Info from "@mui/icons-material/Info";
import Warning from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import MuiSnackbar from "@mui/material/Snackbar";
import capitalize from "lodash/capitalize";
import React, { useCallback, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { SnackbarContext } from "../contexts/snackbar";
var icons = {
    Info: Info,
    Warning: Warning,
    Error: Error
};
var useStyles = makeStyles()(function(theme) {
    return {
        closeSnackbar: {
            width: theme.spacing(4)
        },
        snackbar: {
            marginTop: "4em"
        },
        snackMessage: {
            display: "inline-block",
            marginLeft: "10px",
            verticalAlign: "middle"
        },
        errorIcon: {
            color: "#ff6251",
            verticalAlign: "middle"
        },
        infoIcon: {
            color: "#75beff",
            verticalAlign: "middle"
        }
    };
});
var Snackbar = function(param) {
    var children = param.children;
    var ref = useState([]), queue = ref[0], setQueue = ref[1];
    var ref1 = useState(false), shouldTransitionOut = ref1[0], setShouldTransitionOut = ref1[1];
    var goToNextMessage = useCallback(function() {
        setQueue(function(param) {
            var _param = _to_array(param), restOfQueue = _param.slice(1);
            return restOfQueue;
        });
        setShouldTransitionOut(false);
    }, []);
    var spawn = useCallback(function(message) {
        var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info";
        setQueue(function(currentQueue) {
            if (currentQueue.some(function(entry) {
                return entry.content === message;
            })) {
                return currentQueue;
            }
            return _to_consumable_array(currentQueue).concat([
                {
                    key: Date.now(),
                    content: message,
                    level: level
                }, 
            ]);
        });
        setShouldTransitionOut(false);
    }, []);
    var handleClose = useCallback(function(_event) {
        var reason = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        if (reason !== "clickaway") {
            setShouldTransitionOut(true);
        }
    }, []);
    var classes = useStyles().classes;
    var message = queue[0];
    var level = message && message.level || "info";
    var Icon = icons[capitalize(level)];
    var messageContent = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: classes["".concat(level, "Icon")]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: classes.snackMessage,
                children: message && message.content || ""
            })
        ]
    });
    var action = /*#__PURE__*/ _jsx(IconButton, {
        "aria-label": "Close",
        color: "inherit",
        className: classes.closeSnackbar,
        onClick: handleClose,
        children: /*#__PURE__*/ _jsx(Close, {})
    }, "close");
    return /*#__PURE__*/ _jsxs(SnackbarContext.Provider, {
        value: {
            spawn: spawn
        },
        children: [
            children,
            /*#__PURE__*/ _jsx(MuiSnackbar, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                open: !!message && !shouldTransitionOut,
                autoHideDuration: 6000,
                onClose: handleClose,
                TransitionProps: {
                    onExited: goToNextMessage
                },
                className: classes.snackbar,
                message: messageContent,
                action: action
            })
        ]
    });
};
export default Snackbar;
